import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AssetUIModel, ClientEnvironment, ENVIRONMENT, PROMPTS, ViewType, anyAsset } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';
import { Observable } from 'rxjs';
import { AssetViewTypeService } from '../../../../services/asset-view-type.service';
import { AssetEditPopupComponent } from '../../../asset-edit-popup/asset-edit-popup.component';
import { MenuSettingsData } from '../../collection-asset-view/asset-view-actions/menu-settings-data';
import { CollectionEventsService } from '../../services/collection-events.service';

@Component({
  selector: 'thehubz-collections-list-actions',
  templateUrl: './collections-list-actions.component.html',
  styleUrls: ['./collections-list-actions.component.scss'],
})
export class CollectionsListActionsComponent implements OnInit, OnChanges {
  @Input() filteredList: AssetUIModel[] = [];
  @Input() currentTab = '';
  @Input() appliedFilters!: AnyType;
  @Input() selectedViewType!: ViewType;
  @Input() selectedViewSection2: ViewType = 'sortByLastCreated';
  @Input() sortByNew!: boolean;
  @Input() assetCount!: number;
  @Input() gridSettingsKeySuffix = 'CollectionsOverview';
  @Input() filterBubbles: AnyType;
  @Input() collectionId = '';
  @Input() filterCollectionFormData!: AnyType;
  @Input() selectedFilterObject!: AnyType;
  @Input() formResetter!: Observable<{ _id: string; name: string; key: string } | undefined>;

  @Output() downloadClick = new EventEmitter<AnyType>();
  @Output() publishCollection = new EventEmitter<AnyType>();
  @Output() shareCollection = new EventEmitter<AnyType>();
  @Output() addToDashboard = new EventEmitter<AnyType>();
  @Output() applyFilters = new EventEmitter<AnyType>();
  @Output() deleteCollection = new EventEmitter<AnyType>();
  @Output() resetForm = new EventEmitter<AnyType>();
  @Output() updateFormData = new EventEmitter<AnyType>();
  @Output() currentSize = new EventEmitter<number>();
  @Output() sortBy = new EventEmitter<AnyType>();
  @Output() restFormField = new EventEmitter<AnyType>();
  @Output() selectAll = new EventEmitter<AnyType>();
  @Output() splitCollections = new EventEmitter<AnyType>();
  @Output() changeView = new EventEmitter<AnyType>();

  AnyAsset = anyAsset;

  bulkEditButtonText = $localize`Bulk edit`;
  fullCollectionDownload!: boolean;

  size = 4;
  itemSize = 310;

  collectionsGalleryMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_GALLERY_MENU_SETTINGS);
  collectionsTableMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_TABLE_MENU_SETTINGS);

  dialogEditRef!: MatDialogRef<AssetEditPopupComponent>;

  searchText = '';
  searchPlaceholder = PROMPTS.PLACEHOLDER.SEARCH;
  isMobileSearchOpen = false;

  CustomClients = CustomClients;
  brandingKey!: CustomClients;
  tableData: AnyType;

  constructor(
    @Inject(ENVIRONMENT) protected readonly env: ClientEnvironment,
    private dialog: MatDialog,
    private collectionEventsService: CollectionEventsService,
    protected assetViewTypeService: AssetViewTypeService,
  ) {}

  ngOnInit(): void {
    this.brandingKey = this.env.brandingKey;
    this.selectedViewType = 'grid_4';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filteredList']) {
      if (this.filteredList.length) {
        const availableAssets = this.filteredList
          .map((asset) => {
            if (!asset.assetExpiryDays || asset.assetExpiryDays > 0) {
              return 1;
            }
            return 0;
          })
          .filter((value) => value !== 0).length;

        this.fullCollectionDownload = this.filteredList.length === availableAssets;
      }
    }
  }

  onApplyFilters(event: any) {
    if (event) {
      this.applyFilters.emit(event);
    } else {
      this.applyFilters.emit({});
    }
  }

  editAssets(event: Event) {
    this.dialogEditRef = this.dialog.open(AssetEditPopupComponent, {
      maxWidth: '120rem',
      width: '90%',
      height: '90%',
      data: event,
    });
    this.dialogEditRef.disableClose = true;
    this.dialogEditRef.afterClosed().subscribe(async (result: AssetUIModel[]) => {
      if (result) {
        console.log(result);
      }
    });
  }
  /**
   * SearchField methods
   */

  searchTextChanged(event: any) {
    this.searchText = event;
    this.collectionEventsService.collectionListSearchFilter$.next(event);
  }

  clearSearch(event: any) {
    this.searchText = event;
    this.collectionEventsService.collectionListSearchFilter$.next(event);
  }

  toggleMobileSearch() {
    this.isMobileSearchOpen = !this.isMobileSearchOpen;
    if (this.isMobileSearchOpen) {
      document.querySelector('.action-container')?.classList.remove('mb-8');
    }
    if (!this.isMobileSearchOpen) {
      this.searchText = '';
      document.querySelector('.action-container')?.classList.add('mb-8');
    }
  }
  onEvent(event: any) {
    this.isMobileSearchOpen = false;
    this.searchText = '';
    document.querySelector('.action-container')?.classList.add('mb-8');
  }
}
